module.exports = __webpack_public_path__ + "static/media/maysa.8a6af281.jpeg";